
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import FlowContainer from '../FlowContainer.vue'
import ActivityTile from '../ActivityTile.vue'
import animate from 'velocity-animate'
import { ProjectPath, ProjectRow, ProjectActivity } from '../../channel.types'

export default Vue.extend({
  data() {
    return {
      //A mock path object, and for this component we only need the row.
      path: {
        row: {
          layout_class: 'landscape_description',
          layout: 'flow',
          is_enabled_activity_clickthrough: true,
          is_enabled_second_screen: true,
          id: 'search_results_portal',
        },
      },
    }
  },

  computed: {
    ...mapState(['search_query', 'search_query_regex', 'selection']),
    ...mapGetters({
      _portalName: 'portalName',
      searchResults: 'searchResults',
    }),

    portalName() {
      return this._portalName(this.path)
    },

    activities: function() {
      return this.searchResults
    },
  },
  components: {
    ActivityTile,
    FlowContainer,
  },
  methods: {
    clearSearch() {
      this.$store.dispatch('reset_search')
    },

    getProjectPath(row, row_index, activity, activity_index) {
      return {
        row,
        row_index,
        activity,
        activity_index,
      }
    },
  },

  destroyed() {
    if (this._portalName(this.selection) === this.portalName) {
      this.$store.commit('setPath', null)
    }
  },
})
